import { saveAs } from "file-saver";
import Box from "@mui/material/Box";
import React, { useState } from "react";
import ImageViewer from "components/image-viewer";
import {
  HorizontalScrollBar,
  VerticalScrollBar,
} from "components/scrollbar/style";
import FileItemWithNameDescription from "./file-item-with-name-description";

function FilesListWithNameDescription({
  files,
  onUpdate,
  onRetry,
  deleteImage,
  disabled,
  onNameChange,
  onDescriptionChange,
  isDetailAvailable = false,
}) {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [activePhotoIndex, setActivePhotoIndex] = useState(0);

  const viewFileButtonClicked = (index) => {
    setIsGalleryOpen(true);
    setActivePhotoIndex(index);
  };

  const removeFileButtonClicked = (file, index) => {
    if (file.isLocal || file.failed) {
      let filesList = [...files];
      filesList.splice(index, 1);
      onUpdate(filesList);
    } else {
      deleteImage(file, index);
    }
  };

  const downloadFileButtonClicked = (file) => {
    let path = null;

    if (file?.originalFile) {
      path = file.originalFile;
    } else if (file?.photo) {
      path = file.photo;
    } else if (file?.video) {
      path = file.video;
    } else if (file?.file?.url) {
      path = file.file.url;
    } else if (file?.file) {
      path = file.file;
    }
    if (path) {
      saveAs(path);
    }
  };

  const retryUploadFileButtonClicked = (file, index) => {
    if (onRetry) {
      onRetry(file, index);
    }
  };

  const renderFiles = (files) => {
    return (
      files &&
      files.map((file, index) => (
        <Box key={file?.id}>
          <FileItemWithNameDescription
            file={file}
            disabled={disabled}
            isDetailAvailable={isDetailAvailable}
            onClickView={() => viewFileButtonClicked(index)}
            onClickDownload={() => downloadFileButtonClicked(file)}
            onClickRemove={() => removeFileButtonClicked(file, index)}
            onClickRetry={() => retryUploadFileButtonClicked(file, index)}
            onNameChange={(e) => onNameChange(e, index)}
            onDescriptionChange={(e) => onDescriptionChange(e, index)}
          />
        </Box>
      ))
    );
  };

  const renderView = () => {
    return (
      <>
        {renderFiles(files)}
        <ImageViewer
          show={isGalleryOpen}
          photos={files}
          activePhotoIndex={activePhotoIndex}
          onClose={() => setIsGalleryOpen(false)}
        />
      </>
    );
  };

  if (isDetailAvailable) {
    return <VerticalScrollBar>{renderView()}</VerticalScrollBar>;
  } else {
    return <HorizontalScrollBar>{renderView()}</HorizontalScrollBar>;
  }
}

export default FilesListWithNameDescription;
